import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    tableHeader: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    tableActions: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
  };
};
